export default __webpack_public_path__ + "static/COAT-testimonial-63f1b1b772d03471497c5ab8de6598a3.mp4";